import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { MODULI_MENU, MODULI_PRATICA } from "../lib/moduli";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

const ALL = [...MODULI_MENU.map((m) => ({ ...m, g: "Menu" })), ...MODULI_PRATICA.map((m) => ({ ...m, g: "Pratica" }))];

const ModList = ({ title, items, color, testId }) => (
  <div data-testid={testId}>
    <div className={`text-xs font-semibold mb-1 ${color}`}>{title} ({items.length})</div>
    {items.length ? (
      <ul className="flex flex-wrap gap-1.5">
        {items.map((m) => <li key={m.key} className="rounded border border-slate-200 bg-slate-100 px-2 py-0.5 text-xs text-slate-800">{m.label}<span className="ml-1 text-[10px] text-slate-500">{m.g}</span></li>)}
      </ul>
    ) : <div className="text-xs text-slate-500">Nessuno</div>}
  </div>
);

export const PianoChangeConfirm = ({ tenantId, from, to, onConfirm, onCancel }) => {
  const [diff, setDiff] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/admin/moduli-piani"), api.get(`/admin/tenants/${tenantId}/moduli`)]).then(([p, m]) => {
      const preset = (p.data.piani || []).find((x) => x.nome.toLowerCase() === (to || "").toLowerCase());
      if (!preset) { setDiff({ none: true }); return; }
      const cur = new Set(m.data.disattivati || []);
      const next = new Set(preset.disattivati || []);
      setDiff({ on: ALL.filter((x) => cur.has(x.key) && !next.has(x.key)), off: ALL.filter((x) => !cur.has(x.key) && next.has(x.key)) });
    }).catch(() => setDiff({ none: true }));
  }, [tenantId, to]);
  return (
    <AlertDialog open onOpenChange={(o) => { if (!o) onCancel(); }}>
      <AlertDialogContent data-testid="piano-change-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>Cambiare piano?</AlertDialogTitle>
          <AlertDialogDescription>
            Da <b className="text-slate-900">{from || "Nessun piano"}</b> a <b className="text-amber-600">{to || "Nessun piano"}</b>. Le modifiche ai moduli si applicano al salvataggio dello studio.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {!diff ? <div className="py-4 flex justify-center"><Loader2 className="h-5 w-5 animate-spin" /></div> : diff.none ? (
          <div className="text-sm text-slate-600" data-testid="piano-change-none">Questo piano non ha moduli predefiniti: i moduli dello studio restano invariati.</div>
        ) : (diff.on.length + diff.off.length === 0) ? (
          <div className="text-sm text-slate-600" data-testid="piano-change-same">I moduli dello studio sono già quelli del piano: nessuna modifica.</div>
        ) : (
          <div className="space-y-3">
            <ModList title="Verranno attivati" items={diff.on} color="text-emerald-700" testId="piano-change-on" />
            <ModList title="Verranno disattivati" items={diff.off} color="text-red-600" testId="piano-change-off" />
          </div>
        )}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="piano-change-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={!diff} data-testid="piano-change-ok" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">Conferma cambio</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
